import Vue from "vue";
import router from "./router";
import { makeGetConfigRequest } from "./services/config";
import appConfigStore from "./config/appConfigStore";
import FloatingVue from "floating-vue";

import "floating-vue/dist/style.css";
import "./assets/app.scss";

var SmoothScroll = require("smooth-scroll");
new SmoothScroll('a[href*="#"]', {
  offset: 170,
});

// Listen for scroll events
document.addEventListener(
  "scrollStart",
  (e) => {
    let active = document.querySelectorAll("a.active[data-scroll]");
    if (active) {
      for (let i = 0; i < active.length; i++) {
        active[i].classList.remove("active");
      }
    }

    e.detail.toggle.classList.add("active");
  },
  false
);

Vue.config.productionTip = true;
Vue.use(FloatingVue, {
  popperTriggers: ["click hover focus"],
  theme: {
    tooltip: {
      triggers: ["hover", "focus", "touch"],
      delay: {
        show: 200,
        hide: 0,
      },
      handleResize: false,
    },
  },
});

const render = async () => {
  const config = await makeGetConfigRequest();
  appConfigStore.config = config;
  const importApp = await import("./App.vue");
  const App = importApp.default;
  new Vue({
    router,
    render: (h) => h(App),
  }).$mount("#app");
};

render();
